// tslint:disable:max-file-line-count
import * as React from 'react';
import { Component } from 'react';

import {
  getKeyboardEventCode,
  IDropdownValue,
  mergeStyles,
  Popup,
  PopupArrow,
  Preloader,
} from '@cian/components';
import { OutsideClick } from '@cian/outside-click-component';
import { TextField } from '@cian/text-field-component';

import { getOfferType, scrollTo } from './utils';

import { createMakeRequest } from '../../../../browser/client';
import * as Analytics from '../../../helpers/analytics_helper';
import {
  IAddressSuggestion,
  IMultiSuggestParams,
  IMultiSuggestResult,
} from '../../../helpers/geo_suggest';
import { IMakeRequest } from '../../../helpers/network_helper';
import {
  IUserGeoDefinitionWithFilter,
  TUserGeoSearch,
} from '../../../models/filters/user_geo';
import { IGeoValue } from '../../../redux/modules/search/search';
import {
  getGeoBoundedBy,
  IGeoObject,
  sendGeocode,
} from './geo_suggest/geo_helpers';
import {
  getGeoRegionName,
} from './geo_suggest/suggests_helpers';
import { Suggestions } from './geo_suggest/suggests_helpers';

import {
  IBuildingSuggest,
  ILocationSuggest,
  IRailwaySuggest,
  IUndergroundSuggest,
  TMatches,
  TSuggestType,
} from '../../../helpers/structured_suggest';

import { debounce, flatten, isEmpty, values as objectValues } from 'lodash';

import {ISetUserGeo} from '../../../redux/modules/search/user_geo';

export type TGroupItemsType = ILocationSuggest[] | IAddressSuggestion[] | IBuildingSuggest[] | IUndergroundSuggest[];

interface IItemClickParams {
  title: string;
  group: TSuggestType;
  id?: number;
  regionId?: number;
}

interface IUserGeoMultiFilterProps {
  abGroup?: number;
  buildingType: string;
  searchType: string;
  section: string;
  regionOrMaintownId: number;
  regions: IDropdownValue[];
  cities: IDropdownValue[];
  geoValue?: IGeoValue;
  bsCenterId?: number;
  text?: string;
  placeholder: string;
  countrysideSuggestEnabled: boolean;

  onChange(
    userGeoDefinitionWithFilter: IUserGeoDefinitionWithFilter,
    userGeoSearch: TUserGeoSearch,
  ): void;

  getMultiSuggest(params: IMultiSuggestParams): Promise<IMultiSuggestResult>;
  onGeoSelected(value: IGeoObject, countrysideSuggestEnabled?: boolean): void;
  onGeoSuggestChange(geoSuggest: string | void): void;
  setUserGeo: ISetUserGeo;
}

interface IUserGeoMultiFilterState {
  text?: string;
  suggestions?: Suggestions;
  isPopupOpen?: boolean;
  isLoad?: boolean;
  selectedItemIndex?: number;
  selectedValue?: string;
  error?: boolean;
  geoBoundedBy?: [IYmapsCoord, IYmapsCoord];
  multiSuggest?: IMultiSuggestResult;
  defaultGeoText?: string;
}

const MAX_LENGTH_INPUT_TEXT = 255;
// default displayed Moscow
const BOUNDED_BY_DEFAULT: [IYmapsCoord, IYmapsCoord] = [
  [56.021224, 37.967428],
  [55.142175, 36.803101],
];
const ITEMS_GROUPS_NAMES = {
  roads: 'roads',
  cities: 'cities',
  railways: 'railways',
  villages: 'villages',
  addresses: 'addresses',
  districts: 'districts',
  newbuildings: 'newbuildings',
  undergrounds: 'undergrounds',
  businessCenters: 'businessCenters',
  shoppingCenters: 'shoppingCenters',
};

const styles = require('../search_filters.css');

export class UserGeoMultiFilter extends Component<IUserGeoMultiFilterProps, IUserGeoMultiFilterState> {
  protected container: HTMLDivElement;
  protected suggestionElements: HTMLDivElement[];
  private makeRequest: IMakeRequest;
  private geoInput: TextField;
  private suggestionLastIndex = 0;

  public constructor(props: IUserGeoMultiFilterProps) {
    super(props);

    const text = props.text || getGeoRegionName(
      props.cities,
      props.regions,
      props.regionOrMaintownId,
      props.geoValue,
    );

    const defaultGeoText = text || props.regions[0].label;

    this.state = {
      error: false,
      isLoad: false,
      isPopupOpen: false,
      selectedItemIndex: 0,
      selectedValue: defaultGeoText,
      suggestions: [],
      text: defaultGeoText,
      defaultGeoText,
    };
  }

  public componentWillReceiveProps(nextProps: IUserGeoMultiFilterProps) {
    // Если поменяли регион или ЖК в геосаджесте, то меняем текст кнопки
    if (this.props.regionOrMaintownId !== nextProps.regionOrMaintownId
        || this.props.bsCenterId && !nextProps.bsCenterId) {
      const {cities, regions} = this.props;
      const {geoValue, regionOrMaintownId} = nextProps;

      const text = nextProps.text || getGeoRegionName(cities, regions, regionOrMaintownId, geoValue);

      if (text) {
        this.setState({
          text,
          defaultGeoText: text,
          selectedValue: text,
        });
      }
    } else if (this.props.text !== nextProps.text) {
      const { text } = nextProps;
      this.setState({
        text,
        defaultGeoText: text,
        selectedValue: text,
      });
    }
  }

  public componentDidMount() {
    this.makeRequest = createMakeRequest(
      window.__mainpage_api_host__ || window.location.host,
    );

    const { regionOrMaintownId } = this.props;

    getGeoBoundedBy(this.makeRequest, regionOrMaintownId)
      .then((response) => {
        this.setState({
          geoBoundedBy: [
            [response.data.boundedBy.upperCorner.lat, response.data.boundedBy.upperCorner.lng],
            [response.data.boundedBy.lowerCorner.lat, response.data.boundedBy.lowerCorner.lng],
          ],
        });
      })
      .catch(error => {
        this.setState({
          // Если случилась ошибка, по умолчанию ранжируем suggest по Москве
          geoBoundedBy: BOUNDED_BY_DEFAULT,
        });
      });
  }

  public render() {
    this.suggestionElements = [];

    return (
      <div
        role="search"
        {...mergeStyles(
          styles['c-filters-field'],
          styles['c-filters-field-region'],
        )}
      >
        {
          this.state.isLoad &&
          <div className={styles['c-filterst-field_container-preloader']}>
            <Preloader />
          </div>
        }
        <OutsideClick
          onOutsideClick={() => this.handleOutsideClick()}
          rootElement={<div className={styles['c_filters-suggest_input_wrapper']} />}
        >
          <label
            htmlFor="c_filters-suggest_input"
            {...mergeStyles(styles['c_filters-geo_input_label'], styles['multi-geo-label'])}
          >
            {this.props.placeholder}
          </label>
          <TextField
            ref={(geoInput: TextField) => this.geoInput = geoInput}
            id="c_filters-suggest_input"
            inputStyle={
              `${styles['c_filters-suggest_input_field']}
               ${styles['c_filters-suggest_input_field--small']}`
            }
            value={this.state.text || ''}
            onValueChange={this.handleNextTextChange}
            onKeyDown={this.handleKeyDown}
            onFocus={this.handleFocusGeoInput}
          />
          <button
            type="button"
            {...mergeStyles(
              styles['c_filters-suggest_input-drop_icon'],
              styles['c_filters-suggest_input-drop_icon--strict_filter'],
              this.state.isPopupOpen && styles['c_filters-suggest_input-drop_icon--opened'],
            )}
            onClick={() => this.handleDropDownChevronClick()}
          />
          {
            this.state.isPopupOpen &&
            <Popup
              arrow={PopupArrow.NONE}
              containerStyle={mergeStyles(styles['c_filters-suggest_popup'], styles['multi-popup'])}
            >
                  {
                    this.state.error
                      ? this.renderError()
                      : this.state.multiSuggest && this.renderMultiSuggest(this.state.multiSuggest)
                  }
            </Popup>
          }
        </OutsideClick>
      </div>
    );
  }

  public scrollTo(index: number, center: boolean = false) {
    const containerElement = this.container;
    const valueElement = this.suggestionElements[index];

    if (!valueElement) {
      return;
    }

    const parentElement = valueElement.parentElement && valueElement.parentElement.parentElement;
    if (parentElement) {
      scrollTo({ center, containerElement, targetElement: valueElement, parentElement });
    }
  }

  private handleDropDownChevronClick = () => {
    if (this.state.isPopupOpen) {
      this.geoInput.blur();
      this.handleOutsideClick();
    } else {
      this.geoInput.focus();
    }
  }

  private renderHighlightedText = (text: string, matchesUnsorted: TMatches) => {
    const matches = matchesUnsorted.sort((matchA, matchB) => matchA[0] - matchB[0]);
    const value = (text || '').trim();

    if (!value || matches.length === 0) {
      return <span>{text}</span>;
    }

    return (
      <span>
        {matches.map((match, index) => {
          return (
            <span key={index}>
              {index === 0 && text.substring(0, match[0])}
              <strong>{text.substring(match[0], match[1])}</strong>
              {index === matches.length - 1
                ? text.substring(match[1])
                : text.substring(match[1], matches[index + 1][0])}
            </span>
          );
        })}
      </span>
    );
  }

  private combineGroups = (multiSuggest: IMultiSuggestResult) => {
    const { suggestions, sortOrder } = multiSuggest;
    const keys = Object.keys(suggestions);
    const values = objectValues(suggestions);

    return sortOrder.map((el) => {
      return values[keys.indexOf(el)];
    });
  }

  private chooseGroup = (items: TGroupItemsType, name?: string): JSX.Element => {
    // Кейс с undefined выделен в отдельный if для наглядности происходящего
    // и чтобы обезопаситься от неосторожного использования name!
    if (!name) {
      return this.renderAddresses(items as IAddressSuggestion[]);
    }

    switch (name) {
      case ITEMS_GROUPS_NAMES.addresses:
        return this.renderAddresses(items as IAddressSuggestion[]);
      case ITEMS_GROUPS_NAMES.cities:
        return this.renderLocation(name, 'Город', items as ILocationSuggest[]);
      case ITEMS_GROUPS_NAMES.districts:
        return this.renderLocation(name, 'Район', items as ILocationSuggest[]);
      case ITEMS_GROUPS_NAMES.newbuildings:
        return this.renderBuilding(name, 'Жилые комплексы', items as IBuildingSuggest[]);
      case ITEMS_GROUPS_NAMES.shoppingCenters:
        return this.renderBuilding(name, 'Торговые центры', items as IBuildingSuggest[]);
      case ITEMS_GROUPS_NAMES.businessCenters:
        return this.renderBuilding(name, 'Бизнес-центры', items as IBuildingSuggest[]);
      case ITEMS_GROUPS_NAMES.undergrounds:
        return this.renderUndergrounds(items as IUndergroundSuggest[]);
      case ITEMS_GROUPS_NAMES.railways:
        return this.renderLocation(name, 'Ж/Д Станции', items as IRailwaySuggest[]);
      case ITEMS_GROUPS_NAMES.villages:
        return this.renderBuilding(name, 'Коттеджные поселки', items as IBuildingSuggest[]);
      case ITEMS_GROUPS_NAMES.roads:
        return this.renderLocation(name, 'Шоссе', items as ILocationSuggest[]);
      default:
        return <div/>;
    }
  }

  private getIconStyle = (name: string) => {
    switch (name) {
      case ITEMS_GROUPS_NAMES.newbuildings:
        return styles['newbuildings'];
      case ITEMS_GROUPS_NAMES.shoppingCenters:
        return styles['shop'];
      case ITEMS_GROUPS_NAMES.businessCenters:
        return styles['business'];
      case ITEMS_GROUPS_NAMES.villages:
        return styles['villages'];
      case ITEMS_GROUPS_NAMES.roads:
        return styles['roads'];
      case ITEMS_GROUPS_NAMES.cities:
        return styles['cities'];
      case ITEMS_GROUPS_NAMES.districts:
        return styles['districts'];
      case ITEMS_GROUPS_NAMES.railways:
        return styles['railway'];
      default:
        return '';
    }
  }

  private renderBuilding = (name: string, title: string, items: IBuildingSuggest[]) => {
    return (
      <div>
        <div className={styles['title']}>
          <i className={this.getIconStyle(name)} />
          {title}
        </div>
        {items.map((item, index) => {
          const elementIndex = this.suggestionLastIndex++;
          const {fullName, type, id, regionId} = item;

          return (
            <div {...mergeStyles(
              styles['item'],
              styles['item-building'],
              elementIndex === this.state.selectedItemIndex && styles['item-selected'],
            )}
                 key={index}
                 onClick={() => this.handleGeoSuggestItemClick({ title: fullName, group: type, id, regionId })}
                 onMouseOver={() => this.handleMouseOverGeoItem(elementIndex)}
                 ref={(itemElement: HTMLDivElement) => this.suggestionElements[elementIndex] = itemElement}
                 title={item.name}
            >
              <div className={styles['building-name']}>{this.renderHighlightedText(item.name, item.matches)}</div>
              <div className={styles['address']}>{item.address}</div>
              <a className={styles['link']} href={item.link} target="_blank">
                <i className={styles['link-icon']}/>
              </a>
            </div>
          );
        })}
      </div>
    );
  }

  private renderLocation = (name: string, title: string, items: ILocationSuggest[]) => {
    return (
      <div>
        <div className={styles['title']}>
          <i {...mergeStyles(this.getIconStyle(name))}
        />
          {title}
        </div>
        {items.map((item, index) => {
          const elementIndex = this.suggestionLastIndex++;
          const { id, regionId } = item;

          return (
            <div
              {...mergeStyles(
                styles['item'],
                elementIndex === this.state.selectedItemIndex && styles['item-selected'],
              )}
              onClick={() =>
                this.handleGeoSuggestItemClick({
                  title: item.fullName,
                  group: item.type,
                  id,
                  regionId,
                })
              }
              onMouseOver={() => this.handleMouseOverGeoItem(elementIndex)}
              ref={(itemElement: HTMLDivElement) => this.suggestionElements[elementIndex] = itemElement}
              key={index}
              title={item.name}
            >
              {this.renderHighlightedText(item.name, item.matches)}
            </div>
          );
        })}
      </div>
    );
  }

  private renderUndergrounds = (items: IUndergroundSuggest[]) => {
    return (
      <div>
        <div className={styles['title']}>
          <i className={styles['undergrounds']} />
          Метро
        </div>
        {items.map((item, index) => {
          const elementIndex = this.suggestionLastIndex++;
          const {id, regionId } = item;

          return (
            <div
              {...mergeStyles(
                styles['item'],
                item.underConstruction && typeof item.releaseYear !== 'undefined' && styles['item-unavailable'],
                elementIndex === this.state.selectedItemIndex && styles['item-selected'],
              )}
              onClick={() =>
                this.handleGeoSuggestItemClick({
                  title: item.fullName,
                  group: item.type,
                  id,
                  regionId,
                })
              }
              onMouseOver={() => this.handleMouseOverGeoItem(elementIndex)}
              ref={(itemElement: HTMLDivElement) => this.suggestionElements[elementIndex] = itemElement}
              key={index}
              title={item.name}
            >
              {this.renderHighlightedText(item.name, item.matches)}
              {item.underConstruction && typeof item.releaseYear !== 'undefined'
                ? `\u30fbоткроется в ${item.releaseYear}`
                : null}
            </div>
          );
        })}
      </div>
    );
  }

  private renderAddresses = (items: IAddressSuggestion[]) => {
    return (
      <div>
        <div className={styles['title']}>
          <i className={styles['addresses']}/>
          Адреса
        </div>
        {items.map((item, index) => {
          const elementIndex = this.suggestionLastIndex++;

          return (
            <div {...mergeStyles(
              styles['item'],
              elementIndex === this.state.selectedItemIndex && styles['item-selected'],
            )}
                 key={index}
                 onClick={() => this.handleGeoSuggestItemClick({title: item.displayName, group: 'addresses'})}
                 onMouseOver={() => this.handleMouseOverGeoItem(elementIndex)}
                 ref={(itemElement: HTMLDivElement) => this.suggestionElements[elementIndex] = itemElement}
                 title={item.displayName}
            >
              {this.renderHighlightedText(item.displayName, item.hl as TMatches)}
            </div>
          );
        })}
      </div>
    );
  }

  private renderSuggestions = (multiSuggest: IMultiSuggestResult) => {
    const {sortOrder} = multiSuggest;
    this.suggestionLastIndex = 0;
    const suggestions = this.combineGroups(multiSuggest);

    return (
      <div className={styles['container']}
        ref={(container: HTMLDivElement) => this.container = container}
      >
        {suggestions.map((items, index) => {
          return (
            items &&
              <div className={styles['group-container']} key={index}>
                {this.chooseGroup(items as TGroupItemsType, sortOrder[index])}
              </div>
          );
        })}
      </div>
    );
  }

  private renderMultiSuggest = (multiSuggest: IMultiSuggestResult) => {
    return (
      isEmpty(multiSuggest.suggestions)
        ? this.renderNoSuggestions()
        : this.renderSuggestions(multiSuggest)
    );
  }

  private renderError() {
    return (
      <div className={styles['c_filters-suggested_message_geo']}>
        <div className={styles['c_filters-suggested_message_text']}>
          <div className={styles['c_filters-suggested_message_text--title']}>
            <strong>Не удалось получить возможные варианты</strong>
          </div>
          <div className={styles['c_filters-suggested_message_text--light']}>
            Попробуйте еще раз
          </div>
        </div>
      </div>
    );
  }

  private renderNoSuggestions = () => {
    return (
      <div className={styles['c_filters-suggested_message_geo']}>
        <div className={styles['c_filters-suggested_message_text']}>
          <div className={styles['c_filters-suggested_message_text--title']}>
            <strong>Ничего не найдено</strong>
          </div>
          <div className={styles['c_filters-suggested_message_text--light']}>
            Укажите другой адрес
          </div>
        </div>
      </div>
    );
  }

  private handleFocusGeoInput = () => {
    const {selectedValue, text} = this.state;

    this.setState({error: false, isLoad: true, text: `${selectedValue} `});

    Analytics.trackClickGeoSuggest();

    this.getGeoSuggestion(text || '');
  }

  private selectItem = (index: number) => {
    if (this.suggestionLastIndex === 0) {
      return;
    }

    if (index < 0) {
      index = this.suggestionLastIndex - 1;
    } else if (index > this.suggestionLastIndex - 1) {
      index = 0;
    }

    if (this.state.selectedItemIndex === index) {
      return;
    }

    this.setState({
      selectedItemIndex: index,
    });

    this.scrollTo(index);
  }

  private handleKeyDown = (event: React.KeyboardEvent) => {
    if (!this.state.multiSuggest || isEmpty(this.state.multiSuggest.suggestions)) {
      return;
    }

    const nativeEvent = event.nativeEvent as KeyboardEvent;
    const code = getKeyboardEventCode(nativeEvent);

    const {selectedItemIndex = 0} = this.state;

    switch (code) {
      case 'ArrowDown':
      case 'Down':
        event.preventDefault();
        this.selectItem(selectedItemIndex + 1);
        break;

      case 'ArrowUp':
      case 'Up':
        event.preventDefault();
        this.selectItem(selectedItemIndex - 1);
        break;

      case 'Tab':
      case 'NumpadEnter':
      case 'Enter':
        event.preventDefault();
        this.handleEnterPress();
        break;

      case 'Escape':
        this.setState({
          isPopupOpen: false,
          selectedItemIndex: 0,
          text: this.getTextDisplayed(this.state.selectedValue || ''),
        });
        break;

      default:
        break;
    }
  }

  private getTextDisplayed = (value: string): string => {
    return value.length > MAX_LENGTH_INPUT_TEXT
      ? `${value.slice(0, MAX_LENGTH_INPUT_TEXT).trim()}...`
      : value;
  }

  private formatType = (type: string): string => {
    switch (type) {
      case 'addresses':
        return type;
      case 'city':
        return 'cities';
      case 'railway':
        return type;
      default:
        return type + 's';
    }
  }

  private getQueryTypeLive = (type: string) => {
    switch (type) {
      case 'newbuildings':
        return 'newobject';
      case 'districts':
        return 'district';
      case 'undergrounds':
        return 'underground';
      case 'railway':
        return 'railway';
      case 'roads':
        return 'highway';
      case 'villages':
        return 'village';
      default:
        return 'location';
    }
  }

  private handleEnterPress = () => {
    if (!this.state.multiSuggest || isEmpty(this.state.multiSuggest.suggestions)) {
      return;
    }

    const index = this.state.selectedItemIndex || 0;

    this.geoInput.blur();

    const suggestions = flatten(
      this.combineGroups(this.state.multiSuggest).filter((el) => el) as any
    );
    const selected: any = suggestions[index]; // tslint:disable-line:no-any
    this.handleItemClick({
      title: selected.displayName ? selected.displayName : selected.fullName,
      group: selected.type as TSuggestType,
      id: selected.id,
      regionId: selected.regionId,
    });
  }

  private handleItemClick = (params: IItemClickParams) => {

    this.setState({
      isPopupOpen: false,
      selectedItemIndex: 0,
      text: params.title,
    }, () => this.handleGeoSuggestItemClick(params));
  }

  private handleMouseOverGeoItem(index: number) {
    this.setState({
      selectedItemIndex: index,
    });
  }

  private handleNextTextChange = (newText: string) => {
    this.setState({
      error: false,
      text: newText,
    });

    if (newText.length > 2) {
      this.getGeoSuggestion(newText);
    } else {
      this.setState({isPopupOpen: false, isLoad: false});
    }
  }

  private handleOutsideClick() {
    this.setState({
      isLoad: false,
      isPopupOpen: false,
      selectedItemIndex: 0,
      text: this.getTextDisplayed(this.state.selectedValue || ''),
    });
  }

  private handleGeoSuggestItemClick(params: IItemClickParams) {
    const {title, group, id, regionId} = params;
    const type = this.formatType(group);
    const value = title;
    const newValue = this.getTextDisplayed(value);
    const isCommercial = type === 'shoppingCenters' || type === 'businessCenters';

    this.setState({
      isPopupOpen: false,
      selectedValue: value,
      text: newValue,
    });

    this.props.onGeoSuggestChange(value);

    if (type === 'addresses') {
      sendGeocode(
        this.makeRequest,
        value,
        this.props.section,
        this.props.onChange,
        this.setErrorState,
        true,
      );
    } else if (id) {
      if (!isCommercial) {
        this.props.onGeoSelected({
          bsCenterId: undefined,
          id,
          regionId: regionId || this.props.regionOrMaintownId,
          text: newValue,
          type: this.getQueryTypeLive(type),
        } as IGeoObject, this.props.countrysideSuggestEnabled);
      } else {
        this.props.onGeoSelected({
          bsCenterId: id,
          id: this.props.regionOrMaintownId,
          regionId: regionId || this.props.regionOrMaintownId,
          text: newValue,
          type: 'location',
        } as IGeoObject, this.props.countrysideSuggestEnabled);
      }
      Analytics.trackSelectGeoSuggestItem(type, 'cian');
    }
  }

  private setErrorState = () => {
    this.setState({ error: true, multiSuggest: undefined, isLoad: false, isPopupOpen: true });
  }

  private getGeoSuggestion = debounce((searchText: string) => {
    if (searchText) {
      const {
        regionOrMaintownId,
        getMultiSuggest,
        buildingType,
        searchType,
        countrysideSuggestEnabled,
      } = this.props;
      this.setState({isLoad: true});

      const offerType = getOfferType(buildingType);

      getMultiSuggest({
        structured: {
          offerType,
          query: searchText,
          regionId: regionOrMaintownId,
          searchType,
        },
        yandex: {
          options: { boundedBy: this.state.geoBoundedBy || BOUNDED_BY_DEFAULT, results: 10 },
          value: searchText,
        },
        buildingType,
        countrysideSuggestEnabled,
      })
        .then((result) => {
          if (this.state.text) {
            if (isEmpty(result.suggestions)) {
              Analytics.trackGeoSuggestNotFound(this.state.text);
            }

            this.setState({multiSuggest: result, isLoad: false, isPopupOpen: true});
          } else {
            this.setState({multiSuggest: undefined, isLoad: false, isPopupOpen: false});
          }
        })
        .catch((err) => {
          this.setErrorState();
        });
    }
  }, 300);
}
